import StorageHelper from '../../../helper.js';

const scope = 'ADS/components';

const defaultState = {
    countAds: 0,
    selectedCampaignId: null,
    selectedAdSetId: null,
    selectedAdSetPageId: null,
    selectedAdId: null,
    socialLeadIdToEdit: null,
    selectedFieldMappings: {},
    confirmLetter: null,
    confirmIntegration: null,
    linkedAds: [],
};

const mod = {
    namespaced: true,
    state: {
        campaignId: null,
        countAds: 0,
        selectedCampaignId: null,
        selectedAdSetId: null,
        selectedAdId: null,
        selectedAdSetPageId: null,
        socialLeadIdToEdit: null,
        selectedFieldMappings: {},
        confirmLetter: null,
        confirmIntegration: null,
        linkedAds: [],
    },
    mutations: {
        campaignId: (state, id) => {
            state.campaignId = id;
        },
        countAds: (state, count) => {
          state.countAds = count;
        },
        selectedCampaignId: (state, id) => {
            state.selectedCampaignId = id;
        },
        selectedAdSetId: (state, id) => {
            state.selectedAdSetId = id;
        },
        selectedAdId: (state, id) => {
            state.selectedAdId = id;
        },
        selectedAdSetPageId: (state, pageId) => {
            state.selectedAdSetPageId = pageId;
        },
        socialLeadIdToEdit: (state, id) => {
          state.socialLeadIdToEdit = id;
        },
        selectedFieldMappings: (state, mappings) => {
            state.selectedFieldMappings = mappings;
        },
        confirmLetter: (state, bool) => {
            state.confirmLetter = bool;
        },
        confirmIntegration: (state, bool) => {
            state.confirmIntegration = bool;
        },
        linkedAds: (state, ads) => {
            state.linkedAds = ads;
        },
    },
    actions: {
        campaignId({ commit }, id) {
            StorageHelper.setLocalStorageVar(commit, id, 'campaignId', scope);
        },
        countAds({ commit }, count) {
          StorageHelper.setLocalStorageVar(commit, count, 'countAds', scope);
        },
        selectedCampaignId({ commit }, id) {
            StorageHelper.setLocalStorageVar(commit, id, 'selectedCampaignId', scope);
        },
        selectedAdSetId({ commit }, id) {
            StorageHelper.setLocalStorageVar(commit, id, 'selectedAdSetId', scope);
        },
        selectedAdId({ commit }, id) {
            StorageHelper.setLocalStorageVar(commit, id, 'selectedAdId', scope);
        },
        selectedAdSetPageId({ commit }, pageId) {
            StorageHelper.setLocalStorageVar(commit, pageId, 'selectedAdSetPageId', scope);
        },
        socialLeadIdToEdit({ commit }, id) {
          StorageHelper.setLocalStorageVar(commit, id, 'socialLeadIdToEdit', scope);
        },
        selectedFieldMappings({ commit }, mappings) {
            StorageHelper.setLocalStorageVar(commit, mappings, 'selectedFieldMappings', scope);
        },
        confirmLetter({ commit }, bool) {
            StorageHelper.setLocalStorageVar(commit, bool, 'confirmLetter', scope);
        },
        confirmIntegration({ commit }, bool) {
            StorageHelper.setLocalStorageVar(commit, bool, 'confirmIntegration', scope);
        },
        reset({commit}) {
            StorageHelper.resetState(commit, defaultState, scope);
        },
        linkedAds({ commit }, ads) {
            StorageHelper.setLocalStorageVar(commit, ads, 'linkedAds', scope);
        },
    },
    getters: {
        campaignId(state) {
            return state.campaignId;
        },
        countAds(state) {
            return state.countAds;
        },
        selectedCampaignId (state) {
            return state.selectedCampaignId;
        },
        socialLeadIdToEdit (state) {
          return state.socialLeadIdToEdit;
        },
        selectedAdSetId (state) {
            return state.selectedAdSetId;
        },
        selectedAdId (state) {
            return state.selectedAdId
        },
        selectedAdSetPageId (state) {
            return state.selectedAdSetPageId;
        },
        selectedFieldMappings (state) {
            return state.selectedFieldMappings;
        },
        linkedAds(state) {
            return state.linkedAds;
        },
        confirmLetter: (state) => state.confirmLetter,
        confirmIntegration: (state) => state.confirmIntegration,
    }
};

export default mod;
